import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import ModalOrBottomSheet from '@components/modal-or-bottom-sheet'
import Linkton from '@components/linkton'
import Icon from '@components/icon'
import TextArea from '@components/text-area/text-area'
import MessageVerificationErrors from '@components/message-verification/MessageVerificationErrors'
import useMessageVerification from '@hooks/useMessageVerification'
import { sendUserMessage } from '@common/http'
import { selectCurrentUser } from '@store/selectors/backendData'
import * as styles from './CommunityMessageUser.module.scss'
import * as verificationStyles from '@components/message-verification/MessageVerification.module.scss'

const CommunityMessageUser = (props) => {
  const { isOpen, userId, userName, onClose } = props

  const currentUser = useSelector(selectCurrentUser)

  const [message, setMessage] = useState('')
  const [wasSentOk, setWasSentOk] = useState(false)

  const {
    emailVerificationError,
    externalLinkError,
    blockedError,
    verificationEmailSent,
    sendingVerificationEmail,
    clearErrors,
    resetAll,
    handleSendError,
    handleResendVerificationEmail,
  } = useMessageVerification()

  // reset on open/close
  useEffect(() => {
    setMessage('')
    setWasSentOk(false)
    resetAll()
  }, [isOpen])

  // reverse the effect of setWasSentOk after 2 seconds
  useEffect(() => {
    if (wasSentOk) {
      setTimeout(() => {
        onClose()
        setWasSentOk(false)
      }, 2000)
    }
  }, [wasSentOk, onClose])

  const handleSendMessage = (e) => {
    e.preventDefault()

    clearErrors()
    sendUserMessage(userId, message)
      .then(() => setWasSentOk(true))
      .catch(handleSendError)

    return false
  }

  return (
    <ModalOrBottomSheet open={isOpen} closeShareModal={onClose}>
      {userId ? (
        <div className={styles.container}>
          {wasSentOk ? (
            <div className={styles.success}>
              <div>Message sent to {userName}!</div>
              <div className={styles.successIcon}><Icon icon='check' size={32} /></div>
            </div>
          ) : currentUser?.confirmedAt ? (
            <form onSubmit={handleSendMessage} data-turbolinks={false}>
              <div className={styles.header}>
                <div>Message {userName}</div>
                <Icon icon='new-close' onClick={onClose} size={16} />
              </div>

              <label className={styles.label}>
                MESSAGE
                <TextArea className={styles.textarea} maxLength='2000' onChange={(value) => { setMessage(value); clearErrors() }} fontSize='small' isTransparent={false} value={message} placeholder='Enter your message...' />
              </label>

              <div className={styles.btnContainer}>
                <Linkton className={styles.btn} icon='arrow-forward' iconPlacement='left' isSubmit isDisabled={externalLinkError}>Send</Linkton>
              </div>

              <MessageVerificationErrors
                emailVerificationError={emailVerificationError}
                externalLinkError={externalLinkError}
                blockedError={blockedError}
                verificationEmailSent={verificationEmailSent}
                sendingVerificationEmail={sendingVerificationEmail}
                handleResendVerificationEmail={handleResendVerificationEmail}
              />
            </form>
          ) : (
            <div>
              <div className={styles.header}>
                <div>Message {userName}</div>
                <Icon icon='new-close' onClick={onClose} size={16} />
              </div>
              <div className={verificationStyles.verifyEmailPrompt}>
                <Icon icon='mail' size={24} />
                <small>Verify your email address to send a message!</small>
                {verificationEmailSent ? (
                  <span className={verificationStyles.emailSentConfirmation}>Verification email sent!</span>
                ) : (
                  <Linkton
                    className={styles.btn}
                    onClick={handleResendVerificationEmail}
                    disabled={sendingVerificationEmail}
                  >
                    {sendingVerificationEmail ? 'Sending...' : 'Resend verification email'}
                  </Linkton>
                )}
              </div>
            </div>
          )}
        </div>
      ) : null}
    </ModalOrBottomSheet>
  )
}

export default CommunityMessageUser
